import { Component, Input, OnInit } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { DepositoMovimientosChequeModeloMLS, DepositoService, ObtenerMovimientosDepositoChequeME } from 'src/app/open-api';
import { UserModel } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-deposito-cheque',
  templateUrl: './deposito-cheque.component.html',
  styleUrls: ['./deposito-cheque.component.scss']
})
export class DepositoChequeComponent implements OnInit {

  @Input() set SecuencialDeposito(secuencial: number) {
    this.secuencialDeposito = secuencial;
    this.ObtenerUsuario();
    this.ObtenerMovimientos();
  };
  movimientos: DepositoMovimientosChequeModeloMLS[] = [];
  movimientosLista: DepositoMovimientosChequeModeloMLS[] = [];
  usuario?: UserModel;
  hoy = new Date();
  fechaInicio = new Date(this.hoy.setDate(this.hoy.getDate() - 7));
  fechaFin = new Date();
  secuencialDeposito = 0;
  cantidad = 0;
  pagina = 1;
  paginaTamanio = 3;

  constructor(
    private depositoService: DepositoService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private localeService: BsLocaleService
  ) {
    this.localeService.use('es');
  }

  ngOnInit(): void {
    this.ObtenerUsuario();
  }

  ListarMovimientos() {
    this.movimientosLista = this.movimientos
      .slice((this.pagina - 1) * this.paginaTamanio, (this.pagina - 1) * this.paginaTamanio + this.paginaTamanio);
  }

  ObtenerUsuario() {
    this.authService.user.subscribe(usuario => {
      this.usuario = usuario;
    })
  }

  ObtenerMovimientos() {
    this.spinner.show();
    const parametro: ObtenerMovimientosDepositoChequeME = {
      fechaFin: this.fechaFin,
      fechaInicio: this.fechaInicio,
      secuencialDeposito: this.secuencialDeposito,
      secuencialEmpresa: this.usuario?.secuencialEmpresa
    };
    this.depositoService.apiV10DepositoObtenerMovimientosDepositoChequePost(parametro).subscribe(respuesta => {
      this.movimientos = respuesta.movimientosDepositoCheque || [];
      this.cantidad = this.movimientos.length;
      this.ListarMovimientos();
      this.spinner.hide();
    });
  }

}
